import {
  GuestSchemaResponse,
  GuestSchemaV2Response,
  FormField,
  FormFieldV2,
} from './types';

export const isGuestSchemaV2Response = (
  schema: GuestSchemaResponse | GuestSchemaV2Response,
): schema is GuestSchemaV2Response => {
  return !!(schema as GuestSchemaV2Response).guest_fields;
};

const isFormFieldV2 = (formField?: FormField | FormFieldV2): formField is FormFieldV2 =>
  (formField as FormFieldV2)?.configuration !== undefined;

export const isActiveFormField = (formField?: FormField | FormFieldV2) =>
  isFormFieldV2(formField) ? formField.is_active : formField?.active;

export const isRequiredFormField = (formField?: FormField | FormFieldV2) =>
  isFormFieldV2(formField) ? formField.is_required : formField?.required;
